module.exports = __webpack_public_path__ + "img/foto_top_two.ebb55c92.jpg";